module.exports = __webpack_public_path__ + "static/media/You_tube_ho.c30ec9db.svg";